import {CSSProperties, ReactNode} from "react";
import {Column} from "@web-libs/ui/layout-components/column";
import {DefinedFormFieldElement} from "@web-libs/core/forms/ui/fields/shared/form-field.types";
import {FormLayoutRow} from "@web-libs/core/forms/ui/layout/form-layout-row";

/**
 * [FormLayoutProps]
 * @property fields - 2D array of form fields. Each inner array represents a row of fields.
 * @property button - The button to render at the bottom of the form.
 */

export type FormLayoutProps = {
    fields: DefinedFormFieldElement[][]
    button: ReactNode,
    maxWidth?: number,
}

/**
 * [FormLayout]
 * Is a layout component that renders a form with a button at the bottom.
 * It supports multiple fields in a row.
 */

export const FormLayout = (props: FormLayoutProps) => {

    const getRowKey = (row: DefinedFormFieldElement[]) =>
        row.map(field => field.props.name).join(",")
    const isLastRow = (index: number) => index === props.fields.length - 1

    const renderRow = (row: DefinedFormFieldElement[], index: number) => {
        return (
            <FormLayoutRow row={row} lastRow={isLastRow(index)} key={getRowKey(row)}/>
        )
    }

    return (
        <Column maxWidth={props.maxWidth} fullWidth>
            {props.fields.map(renderRow)}
            {props.button}
        </Column>
    )
}

// Storybook Check
